import React from "react";
import "./Intro.css";
import BestSeller from "../BestSellers/BestSeller";
import Portfolio from "../Portfolio/Portfolio";
import Testimonials from "../../Components/Testimonials/Testimonials";
import Footer from "../../Components/Footer/Footer";
import { connect } from "react-redux";
import * as actions from '../../Store/Actions/index'

const Intro = (props) => {
  document.title =
    "VK Global Publications | Buy latest CBSE books and study material";

  const getCatalogue = () => {
    props.GetBookByInputType("allBooks")
    props.history.push("/catalogue");
  };

  return (
    <div>
      <div className="container">
        <div className="background ">
          <div className="centered">
            <p>Latest Editon</p>
            <p> Economics and Business Studies textbooks </p>
            <p> for class 11 & 12, now available</p>
            <button className="orderNow" onClick={getCatalogue}>
              Order Now
            </button>
          </div>
        </div>
      </div>
      <br></br>
      <BestSeller />
      <Portfolio />
      <Testimonials />
      <Footer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetBookByInputType: (type) => dispatch(actions.GetBookByInputType(type)),
  };
};

export default connect(null,mapDispatchToProps)(Intro);
